import SuggestionsField from '../../SuggestionsField';
import withAutocomplete from '../../Containers/withAutocomplete';

const createQueryString = (props) => {
  let qs = `&st=${props.st}&g=${props.g}`;
  if (props.nearby === true) {
    qs += `&lng=${props.lng}&lat=${props.lat}&nearby=true`;
  }
  return qs;
};

const CaretypeSuggestion = withAutocomplete(
  SuggestionsField,
  '/api/hjv/suggestcaretype',
  (hits) => (hits?.Hits ? hits.Hits : hits),
  () => '',
  (_, value) => value,
  1,
  createQueryString,
  2
);

export default CaretypeSuggestion;
